export const option = {
    SDG: [{
            label: "SDG 1: No Poverty",
            value: "No Poverty"
        },
        {
            label: "SDG 2: Zero Hunger",
            value: "Zero Hunger"
        },
        {
            label: "SDG 3: Good Health and Well-being",
            value: "Good Health and Well-being"
        },
        {
            label: "SDG 4: Quality Education",
            value: "Quality Education"
        },
        {
            label: "SDG 5: Gender Equality",
            value: "Gender Equality"
        },
        {
            label: "SDG 6: Clean Water and Sanitation",
            value: "Clean Water and Sanitation"
        },
        {
            label: "SDG 7: Affordable and Clean Energy",
            value: "Affordable and Clean Energy"
        },
        {
            label: "SDG 8: Decent Work and Economic Growth",
            value: "Decent Work and Economic Growth"
        },
        {
            label: "SDG 9: Industry, Innovation and Infrastructure",
            value: "Industry, Innovation and Infrastructure"
        },
        {
            label: "SDG 10: Reduced Inequalities",
            value: "Reduced Inequalities"
        },
        {
            label: "SDG 11: Sustainable Cities and Communities",
            value: "Sustainable Cities and Communities"
        },
        {
            label: "SDG 12: Responsible Consumption and Production",
            value: "Responsible Consumption and Production"
        },
        {
            label: "SDG 13: Climate Action",
            value: "Climate Action"
        },
        {
            label: "SDG 14: Life below Water",
            value: "Life below Water"
        },
        {
            label: "SDG 15: Life on Land",
            value: "Life on Land"
        },
        {
            label: "SDG 16: Peace, Justice and Strong Institutions",
            value: "Peace, Justice and Strong Institutions"
        },
        {
            label: "SDG 17: Partnership for the Goals",
            value: "Partnership for the Goals"
        },
    ],

    EventWith:[
        "Common",
        "IIC",
        "RISE-Event"
    ],

    ProgramTheme:[
        "IPR",
        "R&D and Innovation",
        "Entrepreneurship",
        "Startup",
        "Design Thinking & Critical Thinking",
        "Incubation and Pre-Incubation",
   ],

    ProgrammType:[
        "Level 1",
        "level 2",
        "level 3",
        "level 4"
    ],

    typeOfActivity:[
        "Workshop",
        "Leadership",
        "Talk",
        "Motivational Speech",
        "Field Visit",
        "Seminar/Case Studies",
        "Exhibition/Demo Day",
        "Contest",
        "FDP",
        "Conference",
        "Techfest and Innovation",
    ],

    RegistringType:[
      "Team",
      "Individual",
      "Both"
    ],

    locationOption: [
        "Online",
        "Offline",
        "Hybrid"
    ],

    activityOption: [
        "International",
        "National",
        "State",
        "University"
    ],

    eventTypeOption: [
        "Cultural",
        "CSR",
        "Co-curriculum",
        "Sports",
        "Technical",
        "NSS"
    ],

    subEventoption: [
        "A day with the Chancellor",
        "Value Added Course",
        "Career Counseling", 
        "Corporate Counseling",
        "Corporate Training",
        "Colloquium",
        "Charity Event",
        "Commemorative day", "Communication Skills",
        "Competition",
        "Conference",
        "Enterpreneurship",
        "Environment or Green Initiative",
        "Exposure visit",
        "Expert Talk",
        "Extension and Outreach programs",
        "Faculty Development Program",
        "Gender Sensitization",
        "Hackathon",
        "Human Values And Ethics",
        "Industry Visit",
        "Innovation and Skill Development",
        "Meditation", "Mind Management",
        "Multilinguism",
        "Orientation",
        "Other", "Patent/IPR",
        "Pre-Placement Talks",
        "Professional Development Training Programme",
        "Seminar",
        "Skill Development Program",
        "Social Event",
        "Soft Skills",
        "Start-up",
        "Student Ambassador",
        "Summit",
        "Stustainable Development Goals",
        "Training",
        "Webinar",
        "Workshop",
        "Yoga"
    ],

    countryOption: [
        "India",
        "Australia"
    ],

    stateOption: [
        "Other",
        "Haryana",
        "Punjab"
    ],

    templateTypeOption: [
        "Please Select ",
        "Participant",
        "Winner",
        "Coordinator",
        "Organizer",
        "Volunteer",
        "Ambassador",
        "Speaker",
        "Mentor",
        "Judge",
        "Award",
        "Achievement",
        "Completion",
        "Experience",
        "Grade",
        "Offer letter",
        "Other"
    ],

    YesNo: [
        "Yes",
        "No"
    ],

    Fee: [
        "Free",
        "Paid"
    ],

    EventIs: [
        "Parent",
        "Child",
        "Individual"
    ],

    MemberOption: [
        "1","2","3","4","5","6","7","8","9","10",  
        "11","12","13","14","15","16","17","18","19","20",                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
    ],
};